import styles from "./Row.module.sass";
import cn from "classnames";
import Checkbox from "../../../../components/Checkbox";

const Row = ({
    item,
    selected,
    onSelect,
    activeTable,
    setActiveTable,
    activeId,
    setActiveId,
}) => {
    const handleClick = (id) => {
        setActiveTable(true);
        setActiveId(id);
    };

    // Fonction pour formater la date
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    // Fonction pour formater le type
    const formatType = (type) => {
        const types = {
            'assistance': 'Assistance',
            'demo': 'Démo',
        };
        return types[type] || type;
    };

    // Fonction pour formater le statut
    const getStatusClass = (status) => {
        switch (status) {
            case 'pending':
                return 'status-yellow';
            case 'processed':
                return 'status-green';
            case 'rejected':
                return 'status-red';
            default:
                return 'status-gray';
        }
    };

    const formatStatus = (status) => {
        const statuses = {
            'pending': 'En attente',
            'processed': 'Traité',
            'rejected': 'Rejeté'
        };
        return statuses[status] || status;
    };

    return (
        <>
            <div
                className={cn(
                    styles.row,
                    { [styles.selected]: activeId === item.id },
                    { [styles.active]: activeTable }
                )}
            >
                <div className={styles.col} onClick={(e) => e.stopPropagation()}>
                    <Checkbox
                        className={styles.checkbox}
                        checked={selected}
                        onChange={(e) => {
                            e.stopPropagation();
                            onSelect && onSelect(item.id);
                        }}
                    />
                </div>
                <div className={styles.col}>
                    <div
                        className={styles.item}
                        onClick={() => handleClick(item.id)}
                    >
                        <div className={styles.avatar}>
                            <img src={'/images/content/user_logo.png'} alt="Logo Offre" />
                        </div>
                        <div className={styles.details}>
                            <div className={styles.user}>{item.nom}</div>
                            <div className={styles.login}>
                            {item.societe && (
                                <div className={styles.company}>{item.societe}</div>
                            )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.col}>
                    <div className={styles.email}>{item.email}</div>
                </div>
                <div className={styles.col}>
                    <div className={cn("status-blue", styles.type)}>
                        {formatType(item.type)}
                    </div>
                </div>
                <div className={styles.col}>
                    <div className={styles.date}>
                        {formatDate(item.created)}
                    </div>
                </div>
                <div className={styles.col}>
                    <div className={cn(getStatusClass(item.status), styles.status)}>
                        {formatStatus(item.status)}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Row;
